/* RESTORING CanaisConfig.js - PART 1 */
import {
    Box,
    Stack,
    Typography,
    Button,
    ListItemButton,
    Divider,
    Autocomplete,
    Alert,
    TextField,
    Chip,
    CircularProgress,
} from '@mui/material';
import axios from 'src/utils/axios';
import InputStyle from 'src/components/InputStyle';
import { RowInput } from 'src/components/forms/RowInput';
import InputStyleMultline from 'src/components/InputStyleMultline';
import { useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import v1_actionEditarFlow from 'src/actions/v1/clientes/v1_actionEditarFlow';
import { useSnackbar } from 'notistack';
import Iconify from 'src/components/Iconify';
import useAuth from 'src/hooks/useAuth';
import v1_actionWboTemplates from 'src/actions/v1/meta/wbo/v1_actionWboTemplates';
import { transformCategoryTemplateWhatsApp } from 'src/utils/meta.utils';
import ChannelDialogflow from './TypesChannels/ChannelDialogflow';
import ChannelLaisAi from './TypesChannels/ChannelLaisAi';
import Scrollbar from 'src/components/Scrollbar';
import ChannelDirect from './TypesChannels/ChannelDirect';
import ChannelHealth from './TypesChannels/ChannelHealth';
import ChannelLaisAiV2 from './TypesChannels/ChannelLaisAiV2';
import { listChatbots } from 'src/actions/v1/chatbots/v1_actionChatbots';
import { Input } from 'src/@/components/ui/input';
import {
    Card,
    CardContent,
    CardDescription,
    CardFooter,
    CardHeader,
    CardTitle,
} from 'src/@/components/ui/card';
import { Label } from 'src/@/components/ui/label';
import { ZuiTooltip } from 'src/@/components/use/tooltip';
import { Switch } from 'src/@/components/ui/switch';
import { Textarea } from 'src/@/components/ui/textarea';
import { Tabs, TabsContent, TabsList, TabsTrigger } from 'src/@/components/ui/tabs';
import { RadioGroup, RadioGroupItem } from 'src/@/components/ui/radio-group';
import { DialogIntegrationsOptions } from './integracoes/DialogIntegrationsOptions';
import { MultiSelect } from 'src/@/components/ui/multi-select';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'src/@/components/ui/select';
import { Separator } from 'src/@/components/ui/separator';
import SelectZui from 'src/components/zui/Select';
import { verifyFeatures, verifyRules } from 'src/utils/functions';
import GenericTable from 'src/components/table/GenericTable';
import { GENERIC_TABLE_DESIGN } from 'src/components/table/GenericTable.design';
import TemplatesWhatsappPage from '../templates-whatsapp';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
    { id: 'name', label: 'Estratégia', align: 'left' },
    { id: 'description', label: 'Descrição', align: 'left' },
    { id: 'status', label: 'Selecionado', align: 'center' },
    { id: 'action', label: 'Ação', align: 'right' },
];

const choices = [
    { id: 1, name: 'Agente IA v2', description: 'Agente simples de IA', value: 'laisai_v2', icon: 'mdi:robot' },
    {
        id: 2,
        name: 'Direcionamento Direto',
        description: 'Direcionamento direto para atendimento humano ou bot',
        value: 'direct',
        icon: 'mdi:arrow-right-bold',
    },
    {
        id: 3,
        name: 'DialogFlow',
        description: 'Integração com DialogFlow',
        value: 'dialogflow_basic',
        icon: 'mdi:chat-processing',
    },
    {
        id: 4,
        name: 'Customizado',
        description: 'Crie fluxos complexos de atendimento',
        value: 'flowbuilder',
        icon: 'mdi:puzzle',
    },
    {
        id: 5,
        name: 'Agente IA (v3)',
        description: 'Crie fluxos complexos de atendimento usando IA e ferramentas',
        value: 'laisai_v3',
        icon: 'mdi:robot-outline',
    },
    { id: 6, name: 'Agente IA (v3.1)', description: '', value: 'lais_agents', icon: 'mdi:robot-industrial' },
    { id: 2, name: 'Api Whatsapp', description: 'Integre seu sistema com nossa api', value: 'api', icon: 'mdi:whatsapp' },
    { id: 8, name: 'Chatbot', description: 'Crie chatbots para atendimento', value: 'chatbot', icon: 'mdi:whatsapp' },
];

const channelsList = [
    {
        id: 1,
        name: 'Whatsapp',
        description: 'Direcionamento direto para atendimento humano ou bot',
        value: 'whatsapp',
        color: 'green-500',
        icon: 'mage:whatsapp-filled',
        disabled: false,
    },
    {
        id: 2,
        name: 'Whatsapp Business Oficial',
        description: 'Direcionamento direto para atendimento humano ou bot',
        value: 'whatsapp_business',
        color: 'blue-500',
        icon: 'uil:whatsapp-alt',
        disabled: false,
    },
];

const ItemChannel = ({ item, selectedIndex, index, onChange }) => {
    const isSelected = selectedIndex === index;
    return (
        <ListItemButton
            disabled={item.disabled}
            sx={{
                border: '1px solid',
                borderColor: isSelected ? 'primary.main' : 'divider',
                borderRadius: 2,
                bgcolor: isSelected ? 'action.selected' : 'background.paper',
                maxWidth: 320,
                width: '100%',
                px: 1.5,
                py: 1,
                transition: 'all 0.2s ease',
                boxShadow: isSelected ? 2 : 0,
                '&:hover': { bgcolor: 'action.hover', transform: 'translateY(-1px)' },
            }}
            selected={isSelected}
            onClick={(event) => onChange(event, index)}
        >
            <Stack direction={'row'} spacing={1.5} alignItems={'center'} sx={{ width: '100%' }}>
                <Box
                    sx={{
                        width: 32,
                        height: 32,
                        borderRadius: 1,
                        display: 'grid',
                        placeItems: 'center',
                        bgcolor: isSelected ? 'primary.lighter' : 'action.hover',
                        color: isSelected ? 'primary.main' : 'text.secondary',
                    }}
                >
                    <Iconify icon={item.icon} width={18} height={18} className={`text-${item.color}`} />
                </Box>
                <Stack spacing={0.25} sx={{ minWidth: 0 }}>
                    <Typography variant="body2" fontWeight={600} noWrap>
                        {item.name}
                    </Typography>
                </Stack>
            </Stack>
        </ListItemButton>
    );
};

const DIAS_SEMANA = [
    { value: 0, label: 'Domingo' },
    { value: 1, label: 'Segunda-feira' },
    { value: 2, label: 'Terça-feira' },
    { value: 3, label: 'Quarta-feira' },
    { value: 4, label: 'Quinta-feira' },
    { value: 5, label: 'Sexta-feira' },
    { value: 6, label: 'Sábado' },
];

function AiSchedulePauseSection({ config, onChange, listUsers, listSectors }) {
    const pause = config?.aiSchedulePause || {};
    const status = !!pause.status;
    const action = pause.action || 'nothing';
    const schedules = Array.isArray(pause.schedules) ? pause.schedules : [];
    const direcionaUsuarios = Array.isArray(pause.direciona_usuarios) ? pause.direciona_usuarios : [];
    const direcionaSetores = Array.isArray(pause.direciona_setores) ? pause.direciona_setores : [];

    const isPausingNow = useMemo(() => {
        if (!status || schedules.length === 0) return false;
        try {
            const parts = new Intl.DateTimeFormat('en-US', {
                timeZone: 'America/Sao_Paulo',
                weekday: 'short',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false,
            }).formatToParts(new Date());
            const map = Object.fromEntries(parts.map((p) => [p.type, p.value]));
            const weekdayMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
            const dayNow = weekdayMap[map.weekday];
            const minutesNow = parseInt(map.hour, 10) * 60 + parseInt(map.minute, 10);
            return schedules.some((s) => {
                if (Number(s.day) !== dayNow) return false;
                const [hs, ms] = (s.startTime || '').split(':').map(Number);
                const [he, me] = (s.endTime || '').split(':').map(Number);
                if (Number.isNaN(hs) || Number.isNaN(he)) return false;
                const start = hs * 60 + ms;
                const end = he * 60 + me;
                return minutesNow >= start && minutesNow < end;
            });
        } catch {
            return false;
        }
    }, [status, schedules]);

    const diasConfigurados = useMemo(() => new Set(schedules.map((s) => Number(s.day))).size, [schedules]);

    const usuariosOptions = useMemo(
        () =>
            (listUsers || []).map((u) => ({
                value: u._id,
                label: u.nomeFantasia || u.nome || u.email || 'Usuário',
            })),
        [listUsers]
    );
    const setoresOptions = useMemo(
        () => (listSectors || []).map((s) => ({ value: s._id, label: s.nome_setor || s.nome || 'Setor' })),
        [listSectors]
    );

    const setField = (name, value) => {
        onChange({ target: { name, value } });
    };

    const updateSchedule = (idx, patch) => {
        const next = schedules.map((s, i) => (i === idx ? { ...s, ...patch } : s));
        setField('aiSchedulePause.schedules', next);
    };

    const moveFaixasToDay = (fromDay, toDay) => {
        if (fromDay === toDay) return;
        const next = schedules.map((s) => (s.day === fromDay ? { ...s, day: toDay } : s));
        setField('aiSchedulePause.schedules', next);
    };

    const addScheduleForDay = (day) => {
        setField('aiSchedulePause.schedules', [
            ...schedules,
            { day, startTime: '08:00', endTime: '18:00' },
        ]);
    };

    const addSchedule = () => {
        const used = new Set(schedules.map((s) => s.day));
        let day = 1;
        for (let d = 1; d <= 6; d++) {
            if (!used.has(d)) {
                day = d;
                break;
            }
        }
        if (used.size === 7) day = 1;
        addScheduleForDay(day);
    };

    const removeSchedule = (idx) => {
        setField('aiSchedulePause.schedules', schedules.filter((_, i) => i !== idx));
    };

    const groupedByDay = useMemo(() => {
        const map = new Map();
        schedules.forEach((s, idx) => {
            const day = s.day ?? 1;
            if (!map.has(day)) map.set(day, []);
            map.get(day).push({ ...s, idx });
        });
        return [...map.entries()].sort((a, b) => a[0] - b[0]);
    }, [schedules]);

    const dayBadgeColors = [
        'bg-rose-50 text-rose-700 border-rose-200',
        'bg-blue-50 text-blue-700 border-blue-200',
        'bg-amber-50 text-amber-700 border-amber-200',
        'bg-emerald-50 text-emerald-700 border-emerald-200',
        'bg-violet-50 text-violet-700 border-violet-200',
        'bg-indigo-50 text-indigo-700 border-indigo-200',
        'bg-pink-50 text-pink-700 border-pink-200',
    ];

    const actionLabel = action === 'redirect' ? 'Direcionar' : 'Pausar IA';
    const targetsCount = direcionaUsuarios.length + direcionaSetores.length;

    return (
        <div
            className={`mt-6 bg-white rounded-2xl border overflow-hidden transition-all duration-300 ${
                status
                    ? 'border-violet-200 shadow-[0_4px_24px_-12px_rgba(124,58,237,0.25)]'
                    : 'border-gray-100'
            }`}
        >
            <div
                className={`relative ${
                    status ? 'bg-gradient-to-br from-violet-50/80 via-white to-white' : 'bg-white'
                }`}
            >
                {status && (
                    <div
                        aria-hidden
                        className="absolute inset-0 opacity-[0.04] pointer-events-none"
                        style={{
                            backgroundImage:
                                'radial-gradient(circle at 1px 1px, #7C3AED 1px, transparent 0)',
                            backgroundSize: '16px 16px',
                        }}
                    />
                )}

                <div className="relative flex items-start justify-between gap-4 p-5">
                    <div className="flex items-start gap-4 min-w-0 flex-1">
                        <div className="flex-1 min-w-0">
                            <div className="flex items-center gap-2 flex-wrap">
                                <h4 className="text-[15px] font-semibold text-gray-900 leading-tight">
                                    Silenciar IA por horário
                                </h4>
                                {status && (
                                    <span className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full bg-violet-100 text-violet-700 text-[10px] font-bold uppercase tracking-wider">
                                        <span className="relative flex w-1.5 h-1.5">
                                            <span className="absolute inset-0 rounded-full bg-violet-500 animate-ping opacity-75" />
                                            <span className="relative w-1.5 h-1.5 rounded-full bg-violet-600" />
                                        </span>
                                        Ativo
                                    </span>
                                )}
                                {isPausingNow && (
                                    <span className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full bg-rose-100 text-rose-700 text-[10px] font-bold uppercase tracking-wider">
                                        <Iconify icon="mdi:pause-circle" width={11} />
                                        Pausando agora
                                    </span>
                                )}
                            </div>
                            <p className="text-xs text-gray-500 mt-1 leading-relaxed">
                                Define dias e faixas em que a IA não deve responder automaticamente.
                            </p>

                        </div>
                    </div>

                    <div className="flex flex-col items-end gap-1.5 shrink-0">
                        <Switch
                            checked={status}
                            onCheckedChange={(value) => setField('aiSchedulePause.status', value)}
                            className="data-[state=checked]:bg-[#7C3AED] scale-110"
                        />
                        <span
                            className={`text-[10px] font-semibold uppercase tracking-wider transition-colors ${
                                status ? 'text-[#7C3AED]' : 'text-gray-400'
                            }`}
                        >
                            {status ? 'On' : 'Off'}
                        </span>
                    </div>
                </div>
            </div>

            {status && (
                <div className="px-5 pb-5">
                    <Separator className="mb-5 bg-gray-200/60" />

                    <div className="flex flex-col gap-5">
                        <div>
                            <Label className="text-xs font-semibold uppercase tracking-wider text-gray-500 mb-2 block">
                                Quando silenciada
                            </Label>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                {[
                                    {
                                        value: 'nothing',
                                        icon: 'mdi:bell-off-outline',
                                        title: 'Não fazer nada',
                                        desc: 'Apenas não disparar a IA, deixar o chat seguir o curso natural.',
                                    },
                                    {
                                        value: 'redirect',
                                        icon: 'mdi:account-arrow-right-outline',
                                        title: 'Direcionar para setor/usuário',
                                        desc: 'Cria o chat como "Pendente" com o direcionamento configurado.',
                                    },
                                ].map((opt) => {
                                    const selected = action === opt.value;
                                    return (
                                        <button
                                            key={opt.value}
                                            type="button"
                                            onClick={() => setField('aiSchedulePause.action', opt.value)}
                                            className={`text-left p-4 rounded-xl border transition-all duration-200 ${
                                                selected
                                                    ? 'border-[#7C3AED] bg-violet-50/50 shadow-sm shadow-[#7C3AED]/10'
                                                    : 'border-gray-200 bg-white hover:border-gray-300 hover:bg-gray-50'
                                            }`}
                                        >
                                            <div className="flex items-start gap-3">
                                                <div
                                                    className={`w-9 h-9 rounded-lg flex items-center justify-center shrink-0 ${
                                                        selected ? 'bg-[#7C3AED] text-white' : 'bg-gray-100 text-gray-500'
                                                    }`}
                                                >
                                                    <Iconify icon={opt.icon} width={18} />
                                                </div>
                                                <div className="flex-1 min-w-0">
                                                    <div className="flex items-center justify-between gap-2">
                                                        <span className="text-sm font-semibold text-gray-900">{opt.title}</span>
                                                        <span
                                                            className={`w-4 h-4 rounded-full border-2 flex items-center justify-center shrink-0 ${
                                                                selected ? 'border-[#7C3AED] bg-[#7C3AED]' : 'border-gray-300 bg-white'
                                                            }`}
                                                        >
                                                            {selected && <span className="w-1.5 h-1.5 rounded-full bg-white" />}
                                                        </span>
                                                    </div>
                                                    <p className="text-xs text-gray-500 mt-1 leading-relaxed">{opt.desc}</p>
                                                </div>
                                            </div>
                                        </button>
                                    );
                                })}
                            </div>
                        </div>

                        {action === 'redirect' && (
                            <div className="p-4 bg-gradient-to-br from-violet-50/60 to-white rounded-xl border border-violet-100">
                                <div className="flex items-center gap-2 mb-3">
                                    <Iconify icon="mdi:account-group-outline" width={16} className="text-violet-600" />
                                    <Label className="text-xs font-semibold uppercase tracking-wider text-violet-700">
                                        Direcionamento
                                    </Label>
                                </div>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                    <div>
                                        <Label className="text-[11px] font-medium text-gray-500 mb-1.5 flex items-center gap-1">
                                            <Iconify icon="mdi:account-outline" width={12} />
                                            Usuários
                                        </Label>
                                        <MultiSelect
                                            key={`aisp-users-${listUsers ? listUsers.length : 0}`}
                                            options={usuariosOptions}
                                            defaultValue={direcionaUsuarios}
                                            onValueChange={(v) => setField('aiSchedulePause.direciona_usuarios', v)}
                                            placeholder="Selecione usuários"
                                            maxCount={2}
                                            className="bg-white border-gray-200 rounded-xl"
                                        />
                                    </div>
                                    <div>
                                        <Label className="text-[11px] font-medium text-gray-500 mb-1.5 flex items-center gap-1">
                                            <Iconify icon="mdi:domain" width={12} />
                                            Setores
                                        </Label>
                                        <MultiSelect
                                            key={`aisp-sectors-${listSectors ? listSectors.length : 0}`}
                                            options={setoresOptions}
                                            defaultValue={direcionaSetores}
                                            onValueChange={(v) => setField('aiSchedulePause.direciona_setores', v)}
                                            placeholder="Selecione setores"
                                            maxCount={2}
                                            className="bg-white border-gray-200 rounded-xl"
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        <div>
                            <div className="flex items-center justify-between mb-3">
                                <div className="flex items-center gap-2">
                                    <Label className="text-xs font-semibold uppercase tracking-wider text-gray-500">
                                        Intervalos de silêncio
                                    </Label>
                                    {schedules.length > 0 && (
                                        <span className="px-2 py-0.5 bg-violet-100 text-violet-700 text-[10px] font-bold rounded-full">
                                            {schedules.length}
                                        </span>
                                    )}
                                </div>
                                <button
                                    type="button"
                                    onClick={addSchedule}
                                    className="flex items-center gap-1.5 px-3 py-2 bg-[#7C3AED] hover:bg-[#6d28d9] text-white text-xs font-medium rounded-xl transition-all shadow-sm shadow-[#7C3AED]/20 active:transform active:scale-95"
                                >
                                    <Iconify icon="eva:plus-outline" width={14} />
                                    Adicionar intervalo
                                </button>
                            </div>

                            {schedules.length === 0 ? (
                                <div className="flex flex-col items-center justify-center py-8 px-4 bg-gray-50/60 border-2 border-dashed border-gray-200 rounded-xl">
                                    <div className="w-12 h-12 rounded-2xl bg-white border border-gray-100 flex items-center justify-center mb-3">
                                        <Iconify icon="mdi:calendar-clock-outline" width={24} className="text-gray-400" />
                                    </div>
                                    <p className="text-sm font-medium text-gray-700">Nenhum intervalo configurado</p>
                                    <p className="text-xs text-gray-500 mt-1 text-center max-w-xs">
                                        Adicione ao menos um dia e horário para que a IA pare de responder no período.
                                    </p>
                                </div>
                            ) : (
                                <div className="flex flex-col gap-2">
                                    {groupedByDay.map(([day, faixas]) => {
                                        const dayBadge = dayBadgeColors[day] || dayBadgeColors[0];
                                        const dayLabel = DIAS_SEMANA[day]?.label || 'Dia';
                                        const usedDays = new Set(schedules.map((s) => s.day));
                                        return (
                                            <div
                                                key={day}
                                                className="group flex items-start gap-3 p-3 bg-white rounded-xl border border-gray-200 hover:border-violet-200 hover:shadow-sm transition-all"
                                            >
                                                <Select
                                                    value={String(day)}
                                                    onValueChange={(value) => moveFaixasToDay(day, Number(value))}
                                                >
                                                    <SelectTrigger
                                                        className={`shrink-0 h-8 w-auto min-w-[130px] gap-1.5 border text-xs font-semibold rounded-lg px-2.5 ${dayBadge} hover:opacity-90 focus:ring-0`}
                                                    >
                                                        <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70" />
                                                        <SelectValue>{dayLabel}</SelectValue>
                                                    </SelectTrigger>
                                                    <SelectContent>
                                                        {DIAS_SEMANA.map((d) => (
                                                            <SelectItem
                                                                key={d.value}
                                                                value={String(d.value)}
                                                                disabled={d.value !== day && usedDays.has(d.value)}
                                                                className="text-xs"
                                                            >
                                                                {d.label}
                                                                {d.value !== day && usedDays.has(d.value) && (
                                                                    <span className="text-[10px] text-gray-400 ml-2">já em uso</span>
                                                                )}
                                                            </SelectItem>
                                                        ))}
                                                    </SelectContent>
                                                </Select>

                                                <div className="flex flex-wrap items-center gap-2 flex-1">
                                                    {faixas.map((f, faixaIdx) => (
                                                        <div
                                                            key={f.idx}
                                                            className="flex items-center gap-1.5 px-1.5 py-1 bg-gray-50 rounded-lg border border-gray-200"
                                                        >
                                                            <div className="flex items-center gap-1 px-1.5">
                                                                <Iconify icon="mdi:clock-outline" width={12} className="text-gray-500" />
                                                                <input
                                                                    type="time"
                                                                    value={f.startTime || ''}
                                                                    onChange={(e) => updateSchedule(f.idx, { startTime: e.target.value })}
                                                                    className="bg-transparent text-xs font-medium text-gray-800 focus:outline-none w-[64px]"
                                                                />
                                                            </div>
                                                            <Iconify icon="eva:arrow-forward-outline" width={12} className="text-gray-400" />
                                                            <div className="flex items-center gap-1 px-1.5">
                                                                <Iconify icon="mdi:clock-outline" width={12} className="text-gray-500" />
                                                                <input
                                                                    type="time"
                                                                    value={f.endTime || ''}
                                                                    onChange={(e) => updateSchedule(f.idx, { endTime: e.target.value })}
                                                                    className="bg-transparent text-xs font-medium text-gray-800 focus:outline-none w-[64px]"
                                                                />
                                                            </div>
                                                            <button
                                                                type="button"
                                                                onClick={() => removeSchedule(f.idx)}
                                                                className="ml-0.5 w-6 h-6 flex items-center justify-center text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-md transition-colors"
                                                                title="Remover faixa"
                                                            >
                                                                <Iconify icon="eva:close-outline" width={14} />
                                                            </button>
                                                        </div>
                                                    ))}
                                                    <button
                                                        type="button"
                                                        onClick={() => addScheduleForDay(day)}
                                                        className="flex items-center gap-1 px-2 py-1 text-[11px] font-medium text-violet-600 hover:text-violet-700 hover:bg-violet-50 rounded-md transition-colors"
                                                        title="Adicionar faixa neste dia"
                                                    >
                                                        <Iconify icon="eva:plus-outline" width={12} />
                                                        Faixa
                                                    </button>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}

                            <div className="flex items-center gap-1.5 mt-3 px-2.5 py-1.5 bg-gray-50 rounded-lg w-fit">
                                <Iconify icon="mdi:earth" width={12} className="text-gray-500" />
                                <span className="text-[11px] text-gray-600 font-medium">Fuso horário: America/Sao_Paulo</span>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default function CanaisConfig({
    isEdit,
    canal,
    onChange,
    onChangeChannel,
    onChangeAutocomplete,
    listUsers,
    listSectors,
    config,
    onSubmit,
    cliente,
    user,
    changeAgent,
}) {
    const navigate = useNavigate();
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [selectedChannelIndex, setSelectedChannelIndex] = useState(0);
    const [templates, setTemplates] = useState([]);
    const [loadingTemplates, setLoadingTemplates] = useState(false);
    const [selectTemplateOpen, setSelectTemplateOpen] = useState(false);
    const [chatbotsList, setChatbotsList] = useState([]);
    const [loadingChatbots, setLoadingChatbots] = useState(false);
    const [selectedTemplateId, setSelectedTemplateId] = useState(() =>
        config?.generalConfig?.feedbackTemplate?.templateId ? String(config.generalConfig.feedbackTemplate.templateId) : 'none'
    );
    const isAdmin = user?.level === 'root';

    const [viewMode, setViewMode] = useState('card');

    const isWhatsAppBusiness = useMemo(() => {
        return canal?.platform === 'whatsapp_business';
    }, [canal?.platform]);

    const templateObrigatorio = useMemo(() => {
        return isWhatsAppBusiness && config?.generalConfig?.feedback;
    }, [isWhatsAppBusiness, config?.generalConfig?.feedback]);

    const normalizarComponents = (components) => {
        if (!Array.isArray(components)) return [];
        return components.map((c) => ({
            ...c,
            type: typeof c.type === 'string' ? c.type.toUpperCase() : c.type,
        }));
    };

    const extrairVariaveisTemplate = (components) => {
        const variaveis = {};
        if (!components || !Array.isArray(components)) {
            return variaveis;
        }
        components.forEach((component) => {
            if (component.text) {
                const matches = component.text.match(/\{\{(\d+)\}\}/g);
                if (matches) {
                    matches.forEach((match) => {
                        const numero = match.replace(/\{\{|\}\}/g, '');
                        variaveis[numero] = '';
                    });
                }
            }
            if (component.buttons && Array.isArray(component.buttons)) {
                component.buttons.forEach((button) => {
                    if (button.text) {
                        const matches = button.text.match(/\{\{(\d+)\}\}/g);
                        if (matches) {
                            matches.forEach((match) => {
                                const numero = match.replace(/\{\{|\}\}/g, '');
                                variaveis[numero] = '';
                            });
                        }
                    }
                });
            }
        });
        return variaveis;
    };

    const buscarTemplates = async () => {
        const idCliente = canal?.cliente_id || user?.clienteId;
        if (!idCliente) return;
        try {
            setLoadingTemplates(true);
            const res = await v1_actionWboTemplates(idCliente);
            setTemplates(res.data?.data?.templates || []);
        } catch (error) {
            console.log('Erro ao buscar templates:', error);
        } finally {
            setLoadingTemplates(false);
        }
    };

    const handleSelecionarTemplate = (templateId) => {
        if (!templateId || templateId === 'none') {
            setSelectedTemplateId('none');
            onChange({ target: { name: 'generalConfig.feedbackTemplate', value: null } });
            onChange({ target: { name: 'generalConfig.feedbackTemplateVariaveis', value: {} } });
            return;
        }
        const templateIdStr = String(templateId);
        const template = templates.find((t) => String(t.templateId || t._id) === templateIdStr);
        if (!template) return;

        const comps = normalizarComponents(template?.components || []);
        const conteudo = comps?.find((c) => c.type === 'BODY')?.text || '';
        const variaveis = extrairVariaveisTemplate(comps);
        const templateData = {
            templateId: String(template.templateId || template._id),
            name: template.name || template.templateName,
            conteudo: conteudo,
            components: comps,
        };

        setSelectedTemplateId(templateIdStr);
        onChange({ target: { name: 'generalConfig.feedbackTemplate', value: templateData } });
        onChange({ target: { name: 'generalConfig.feedbackTemplateVariaveis', value: variaveis } });
    };

    useEffect(() => {
        const templateId = config?.generalConfig?.feedbackTemplate?.templateId
            ? String(config.generalConfig.feedbackTemplate.templateId)
            : 'none';
        if (selectedTemplateId !== templateId) {
            setSelectedTemplateId(templateId);
        }
    }, [config?.generalConfig?.feedbackTemplate?.templateId]);

    useEffect(() => {
        if (isWhatsAppBusiness && config?.generalConfig?.feedback) {
            buscarTemplates();
        }
    }, [isWhatsAppBusiness, config?.generalConfig?.feedback, canal?.cliente_id, user?.clienteId]);

    useEffect(() => {
        if (templateObrigatorio && !config?.generalConfig?.feedbackTemplate) {
            buscarTemplates();
        }
    }, [templateObrigatorio, canal?.cliente_id, user?.clienteId]);

    const buscarChatbots = async () => {
        const idCliente = user?.clienteId;
        if (!idCliente) return;
        try {
            setLoadingChatbots(true);
            const res = await listChatbots(idCliente);
            setChatbotsList(res.data?.data || []);
        } catch (error) {
            console.log('Erro ao buscar chatbots:', error);
        } finally {
            setLoadingChatbots(false);
        }
    };

    useEffect(() => {
        if (canal?.webhook_type === 'chatbot') {
            buscarChatbots();
        }
    }, [canal?.webhook_type, canal?.cliente_id, user?.clienteId]);

    const handleFacebookLogin = () => {
        const facebookAppId = import.meta.env.VITE_FACEBOOK_APP_ID || '2587072681672869';
        const configId = import.meta.env.VITE_FACEBOOK_CONFIG_ID || '1925356381379546';
        const channelId = canal?._id;
        const params = new URLSearchParams({ app_id: facebookAppId, config_id: configId, channel_id: channelId });
        const urlToOpen = `/dashboard/configuracoes/facebook-connect?${params.toString()}`;
        navigate(urlToOpen);
    };

    const newOpcoesMomentos = [
        { label: 'Ao finalizar chat', value: 'finalizar' },
        { label: 'Durante o Chat', value: 'durante' },
    ];

    const newListSectors = listSectors?.map((item) => ({ value: item._id, label: item.nome_setor }));

    const optionsAllocate = [
        {
            label: 'Distribuição uniforme',
            value: 'round_robin',
            description: 'Round robin...',
        },
        { label: 'Aleatório', value: 'random', description: 'Aleatório...' },
        { label: 'Distribuição sequencial', value: 'sequential', description: 'Sequencial...' },
    ];

    const optionsPeriod = [
        { label: 'Mensal (recomendado)', value: 'month', description: 'Mensal...' },
        { label: 'Diário', value: 'daily', description: 'Diário...' },
    ];

    return (
        <Scrollbar sx={{ height: 'calc(90vh - 100px)' }}>
            <Tabs defaultValue="config" className="w-full">
                <TabsList className="mb-6 bg-neutral-200">
                    <TabsTrigger value="config">Configuração</TabsTrigger>
                    <TabsTrigger value="mensagens">Mensagens</TabsTrigger>
                    <TabsTrigger value="setores">Atendimentos</TabsTrigger>
                    <TabsTrigger value="ia">IA</TabsTrigger>
                    {canal?.platform === "whatsapp" && (
                        <TabsTrigger value="saude">Saúde</TabsTrigger>
                    )}
                    {(isAdmin || (verifyRules(user.rules, 'templates_whatsapp') && canal?.platform === 'whatsapp_business')) && (
                        <TabsTrigger value="templates">Templates WhatsApp</TabsTrigger>
                    )}
                </TabsList>
                <TabsContent value="config">
                    <Card className="p-2">
                        <CardContent>
                            <div className="flex flex-col gap-4">
                                <RowInput
                                    sx={{ width: '30%' }}
                                    label="nome do canal"
                                    input={<InputStyle size="small" value={canal?.nome} fullWidth name="channelName" onChange={onChange} />}
                                />
                                <RowInput
                                    label={'canal'}
                                    input={
                                        <Stack sx={{ my: 2 }} spacing={1} direction={'row'}>
                                            {channelsList
                                                .filter((item) => item.value === canal?.platform)
                                                .map((item, index) => (
                                                    <ItemChannel
                                                        key={item.value}
                                                        item={item}
                                                        selectedIndex={canal?.platform}
                                                        index={item.value}
                                                        onChange={() => {
                                                            setSelectedChannelIndex(index);
                                                            onChangeChannel({ target: 'channelType', value: item.value });
                                                        }}
                                                    />
                                                ))}
                                        </Stack>
                                    }
                                />
                                <div className="w-full mt-4">
                                    {canal?.platform === 'whatsapp_business' && (
                                        <div className="flex flex-col w-full">
                                            {/* Facebook Embedded Signup */}
                                            <div className="mb-6 p-4 border border-dashed border-blue-200 rounded-lg bg-blue-50/50">
                                                <div className="flex items-center justify-between">
                                                    <div className="flex flex-col gap-1">
                                                        <h4 className="text-sm font-semibold text-gray-900 flex items-center gap-2">
                                                            <Iconify icon="logos:facebook" width={20} /> Cadastro Incorporado
                                                        </h4>
                                                        <p className="text-xs text-gray-600">
                                                            Conecte sua conta do WhatsApp Business automaticamente usando o Facebook.
                                                        </p>
                                                    </div>
                                                    <Button
                                                        variant="contained"
                                                        startIcon={<Iconify icon="logos:facebook" color="common.white" width={20} height={20} />}
                                                        onClick={handleFacebookLogin}
                                                        sx={{
                                                            bgcolor: '#1877F2',
                                                            '&:hover': { bgcolor: '#166FE5' },
                                                            color: 'white',
                                                            textTransform: 'none',
                                                            fontWeight: 600,
                                                            px: 3,
                                                        }}
                                                    >
                                                        Conectar com Facebook
                                                    </Button>
                                                </div>
                                            </div>
                                            <div className="relative flex items-center py-2 mb-6">
                                                <div className="flex-grow border-t border-gray-200"></div>
                                                <span className="flex-shrink-0 mx-4 text-xs font-semibold text-gray-400 uppercase">
                                                    Ou configure manualmente
                                                </span>
                                                <div className="flex-grow border-t border-gray-200"></div>
                                            </div>
                                            <div className="flex flex-row gap-4 w-full">
                                                <RowInput
                                                    label="Id número"
                                                    input={
                                                        <Input
                                                            size="small"
                                                            onChange={(e) => onChange({ target: { name: 'whatsapp_business_id', value: e.target.value } })}
                                                            value={canal?.config?.meta?.whatsappBusinness.fromNumberId}
                                                            fullWidth
                                                        />
                                                    }
                                                />
                                                <RowInput
                                                    label="Waba ID"
                                                    input={
                                                        <Input
                                                            size="small"
                                                            onChange={(e) => onChange({ target: { name: 'wabaId', value: e.target.value } })}
                                                            value={canal?.config?.meta?.whatsappBusinness.wabaId}
                                                            fullWidth
                                                        />
                                                    }
                                                />
                                                {user?.fullAc && (
                                                    <RowInput
                                                        sx={{ width: '100%' }}
                                                        label="Token do WhatsApp Business Oficial"
                                                        input={
                                                            <Input
                                                                size="small"
                                                                onChange={(e) =>
                                                                    onChange({ target: { name: 'whatsapp_business_token', value: e.target.value } })
                                                                }
                                                                value={canal?.config?.meta?.whatsappBusinness.accessToken}
                                                                fullWidth
                                                            />
                                                        }
                                                    />
                                                )}
                                            </div>
                                            <Divider className="my-4" />
                                        </div>
                                    )}
                                </div>

                                {/* STRATEGY SELECTION SECTION */}
                                <div className="flex flex-row items-center justify-between mt-6 mb-2">
                                    <div className="flex flex-col gap-1">
                                        <span className="text-sm font-semibold text-gray-700"> Estratégia de Atendimento </span>
                                        <span className="text-xs text-gray-500"> Escolha como o atendimento será distribuído </span>
                                    </div>

                                </div>

                                {viewMode === 'card' ? (
                                    <div className="w-1/3">
                                        <RowInput
                                            label={'configuração do canal'}
                                            input={
                                                <SelectZui
                                                    value={canal?.webhook_type || ''}
                                                    list={choices}
                                                    onChange={(value) => {
                                                        const selectedChoice = choices.find((item) => item.value === value);
                                                        const index = choices.findIndex((item) => item.value === value);
                                                        setSelectedIndex(index);
                                                        onChangeChannel({ target: 'webhookType', value: value });
                                                    }}
                                                    placeholder="Selecione uma configuração"
                                                    fullWidth={true}
                                                    itemSelect={(item) => (
                                                        <SelectItem key={item.value} value={item.value}>
                                                            <div className="flex items-center gap-3">
                                                                <Iconify icon={item.icon} width={20} height={20} className="text-gray-600" />
                                                                <div className="flex flex-col">
                                                                    <span className="font-semibold">{item.name}</span>
                                                                    <span className="text-xs text-gray-500">{item.description}</span>
                                                                </div>
                                                            </div>
                                                        </SelectItem>
                                                    )}
                                                />
                                            }
                                        />
                                    </div>
                                ) : (
                                    <div className="w-full mt-4 border rounded-xl overflow-hidden">
                                        <GenericTable headLabels={TABLE_HEAD}>
                                            {choices.map((item) => {
                                                const isSelected = canal?.webhook_type === item.value;
                                                return (
                                                    <div key={item.id} className={GENERIC_TABLE_DESIGN.row.container}>
                                                        {/* Name */}
                                                        <div className={GENERIC_TABLE_DESIGN.common.colMain}>
                                                            <div className="flex items-center gap-3">
                                                                <div
                                                                    className={`p-2 rounded-lg ${isSelected ? 'bg-violet-100 text-violet-600' : 'bg-gray-100 text-gray-500'
                                                                        }`}
                                                                >
                                                                    <Iconify icon={item.icon || 'mdi:puzzle'} width={24} height={24} />
                                                                </div>
                                                                <div>
                                                                    <h3 className="text-sm font-semibold text-gray-900">{item.name}</h3>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* Description */}
                                                        <div className="flex-1 px-4">
                                                            <span className="text-sm text-gray-500">{item.description}</span>
                                                        </div>
                                                        {/* Selected Status */}
                                                        <div className="w-32 flex justify-center">
                                                            {isSelected && (
                                                                <Chip
                                                                    label="Ativo"
                                                                    color="primary"
                                                                    size="small"
                                                                    variant="soft"
                                                                    sx={{ bgcolor: 'primary.lighter', color: 'primary.main', fontWeight: 600 }}
                                                                />
                                                            )}
                                                        </div>
                                                        {/* Actions */}
                                                        <div className="w-32 flex justify-end">
                                                            <Button
                                                                variant={isSelected ? 'outlined' : 'contained'}
                                                                color={isSelected ? 'primary' : 'inherit'}
                                                                size="small"
                                                                onClick={() => {
                                                                    onChangeChannel({ target: 'webhookType', value: item.value });
                                                                }}
                                                                disabled={isSelected}
                                                                sx={{ textTransform: 'none', boxShadow: isSelected ? 0 : 2 }}
                                                            >
                                                                {isSelected ? 'Selecionado' : 'Selecionar'}
                                                            </Button>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </GenericTable>
                                    </div>
                                )}
                                <div>
                                    {(canal?.webhook_type === 'laisai_v2' ||
                                        canal?.webhook_type === 'laisai_v3' ||
                                        canal?.webhook_type === 'lais_agents') &&
                                        isEdit && (
                                            <ChannelLaisAiV2
                                                onChange={onChange}
                                                canal={canal}
                                                config={config}
                                                listUsers={listUsers}
                                                listSectors={listSectors}
                                                user={user}
                                                cliente={cliente}
                                                changeAgent={changeAgent}
                                            />
                                        )}
                                    {canal?.webhook_type === 'direct' && isEdit && (
                                        <ChannelDirect
                                            listUsers={listUsers}
                                            listSectors={listSectors}
                                            canal={canal}
                                            onChange={onChange}
                                            onChangeAutocomplete={onChangeAutocomplete}
                                        />
                                    )}
                                    {canal?.webhook_type === 'dialogflow_basic' && isEdit && (
                                        <ChannelDialogflow canal={canal} onChange={onChange} listUsers={listUsers} listSectors={listSectors} />
                                    )}
                                    {(canal?.webhook_type === 'laisai' ||
                                        canal?.webhook_type === 'laisai_v2' ||
                                        canal?.webhook_type === 'laisai_v3' ||
                                        canal?.webhook_type === 'lais_agents' ||
                                        canal?.webhook_type === 'chatbot' ||
                                        canal?.webhook_type === 'flowbuilder') &&
                                        isEdit && (
                                            <AiSchedulePauseSection
                                                config={config}
                                                onChange={onChange}
                                                listUsers={listUsers}
                                                listSectors={listSectors}
                                            />
                                        )}
                                    {canal?.webhook_type === 'chatbot' && isEdit && (
                                        <div className="mt-6 p-4 border border-gray-200 rounded-lg bg-gray-50">
                                            <div className="flex flex-col gap-4">
                                                <div className="flex items-center gap-2">
                                                    <h4 className="text-md font-semibold text-gray-900">Selecione o Chatbot</h4>
                                                </div>
                                                <div className="w-1/2">
                                                    <Select
                                                        value={config?.chatflow?.chatflow_id || 'none'}
                                                        onValueChange={(value) => {
                                                            onChange({ target: { name: 'chatflow.chatflow_id', value: value === 'none' ? '' : value } });
                                                        }}
                                                        disabled={loadingChatbots}
                                                    >
                                                        <SelectTrigger className="w-full bg-white">
                                                            <SelectValue placeholder={loadingChatbots ? "Carregando chatbots..." : "Selecione um chatbot"} />
                                                            {loadingChatbots && <CircularProgress size={16} />}
                                                        </SelectTrigger>
                                                        <SelectContent className="max-h-[300px]">
                                                            <SelectItem value="none">
                                                                <span className="text-gray-500">Selecione um chatbot</span>
                                                            </SelectItem>
                                                            {chatbotsList.length === 0 ? (
                                                                <div className="px-2 py-6 text-center">
                                                                    <Iconify icon="mdi:robot-off" className="w-10 h-10 text-gray-300 mx-auto mb-2" />
                                                                    <p className="text-sm text-gray-500">Nenhum chatbot disponível</p>
                                                                </div>
                                                            ) : (
                                                                chatbotsList.map((chatbot) => (
                                                                    <SelectItem key={chatbot._id} value={chatbot._id}>
                                                                        <div className="flex items-center gap-3">
                                                                            <div className="w-8 h-8 bg-violet-100 rounded-lg flex items-center justify-center">
                                                                                <Iconify icon="mdi:robot" className="w-5 h-5 text-violet-600" />
                                                                            </div>
                                                                            <div className="flex flex-col">
                                                                                <span className="font-medium text-sm">{chatbot.name}</span>
                                                                                {chatbot.description && (
                                                                                    <span className="text-xs text-gray-500 truncate max-w-[200px]">
                                                                                        {chatbot.description}
                                                                                    </span>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </SelectItem>
                                                                ))
                                                            )}
                                                        </SelectContent>
                                                    </Select>
                                                    {!config?.chatflow?.chatflow_id && (
                                                        <p className="text-xs text-amber-600 mt-2 flex items-center gap-1">
                                                            <Iconify icon="mdi:alert-circle" className="w-3 h-3" />
                                                            Selecione um chatbot para continuar
                                                        </p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </CardContent>
                    </Card>
                </TabsContent>
                <TabsContent value="mensagens">
                    {isEdit && (
                        <Card className="py-5">
                            <CardContent>
                                <h4 className="scroll-m-20 text-md font-semibold tracking-tight"> Mensagens </h4>
                                <Tabs defaultValue="finish">
                                    <TabsList className="grid w-full grid-cols-5 bg-gradient-to-b from-slate-50 to-slate-100 bg-opacity-50 border border-violet-200 text-sm font-medium">
                                        <TabsTrigger value="finish">Finalização</TabsTrigger>
                                        <TabsTrigger value="transfer">Transferência de chat</TabsTrigger>
                                        <TabsTrigger value="feedback">Pesquisa satisfação</TabsTrigger>
                                        <TabsTrigger value="welcome">Mensagem Boas Vindas</TabsTrigger>
                                        <TabsTrigger value="afterTarget">Direcionamento</TabsTrigger>
                                    </TabsList>
                                    <TabsContent value="finish">
                                        <div className="flex flex-col gap-4 mt-8">
                                            <h4 className="scroll-m-20 text-md font-semibold tracking-tight"> Finalização de chat </h4>
                                            <div className="flex items-center space-x-2">
                                                <Switch
                                                    checked={config?.generalConfig?.msgFinish}
                                                    onCheckedChange={(value) => {
                                                        let e = { target: { name: 'generalConfig.msgFinish', value: value } };
                                                        onChange(e);
                                                    }}
                                                    id="airplane-mode"
                                                />
                                                <Label htmlFor="airplane-mode">Enviar mensagem finalização de chat</Label>
                                                <ZuiTooltip content="Mensagem enviada ao cleinte após finalização de um chat">
                                                    <Box>
                                                        <Iconify icon={'ph:info-bold'} width={18} height={18} />
                                                    </Box>
                                                </ZuiTooltip>
                                            </div>
                                            <RowInput
                                                sx={{ width: '100%' }}
                                                label="Mensagem finalização chat"
                                                onChange={() => { }}
                                                input={
                                                    <Textarea
                                                        multiline
                                                        rows={5}
                                                        size="small"
                                                        onChange={onChange}
                                                        name="generalConfig.msgs.finish"
                                                        value={config?.generalConfig?.msgs?.finish}
                                                        fullWidth
                                                    />
                                                }
                                            />
                                        </div>
                                    </TabsContent>
                                    <TabsContent value="transfer">
                                        <div className="flex flex-col gap-4 mt-8">
                                            <h4 className="scroll-m-20 text-md font-semibold tracking-tight"> Transferência de chat </h4>
                                            <div className="flex items-center space-x-2">
                                                <Switch
                                                    checked={config?.generalConfig?.msgTransfer}
                                                    onCheckedChange={(value) => {
                                                        let e = { target: { name: 'generalConfig.msgTransfer', value: value } };
                                                        onChange(e);
                                                    }}
                                                    id="airplane-mode"
                                                />
                                                <Label htmlFor="airplane-mode">Enviar mensagem de transferência de chat</Label>
                                                <ZuiTooltip content="Mensagem enviada ao cliente após ser transferido para um setor ou atendente">
                                                    <Box>
                                                        <Iconify icon={'ph:info-bold'} width={18} height={18} />
                                                    </Box>
                                                </ZuiTooltip>
                                            </div>
                                            <RowInput
                                                sx={{ width: '100%' }}
                                                label="Mensagem Transferência de chat"
                                                info="Use {{nome}} para nome do atendente ou setor a ser transferido e/ou {{nome_atendente}} para nome do atendente do chat"
                                                input={
                                                    <Textarea
                                                        multiline
                                                        rows={5}
                                                        size="small"
                                                        name="generalConfig.msgs.transfer"
                                                        onChange={onChange}
                                                        value={config?.generalConfig?.msgs?.transfer}
                                                    />
                                                }
                                            />
                                        </div>
                                    </TabsContent>
                                    <TabsContent value="feedback">
                                        <div className="flex flex-col gap-4 mt-8">
                                            <h4 className="scroll-m-20 text-md font-semibold tracking-tight"> Pesquisa de satisfação </h4>
                                            <div className="flex items-center space-x-2">
                                                <Switch
                                                    checked={config?.generalConfig?.feedback}
                                                    onCheckedChange={(value) => {
                                                        let e = { target: { name: 'generalConfig.feedback', value: value } };
                                                        onChange(e);
                                                        if (value && isWhatsAppBusiness) {
                                                            buscarTemplates();
                                                        }
                                                        if (!value && isWhatsAppBusiness) {
                                                            onChange({ target: { name: 'generalConfig.feedbackTemplate', value: null } });
                                                            onChange({ target: { name: 'generalConfig.feedbackTemplateVariaveis', value: {} } });
                                                        }
                                                    }}
                                                    id="airplane-mode"
                                                />
                                                <Label
                                                    htmlFor="airplane-mode"
                                                    className={templateObrigatorio && !config?.generalConfig?.feedbackTemplate ? 'text-gray-500' : ''}
                                                >
                                                    Enviar pesquisa de satisfação ao cliente{' '}
                                                    {templateObrigatorio && !config?.generalConfig?.feedbackTemplate && (
                                                        <span className="text-red-600 ml-1">(Template obrigatório)</span>
                                                    )}
                                                </Label>
                                                <ZuiTooltip
                                                    content={
                                                        isWhatsAppBusiness
                                                            ? 'Como o canal é WhatsApp Business, é obrigatório selecionar um template para enviar pesquisa de satisfação quando o feedback estiver ativo'
                                                            : 'Envio de pesquisa de satisfação ao cliente após uma finalização de chat'
                                                    }
                                                >
                                                    <Box>
                                                        <Iconify icon={'ph:info-bold'} width={18} height={18} />
                                                    </Box>
                                                </ZuiTooltip>
                                            </div>

                                            {isWhatsAppBusiness && config?.generalConfig?.feedback ? (
                                                <>
                                                    {templateObrigatorio && !config?.generalConfig?.feedbackTemplate && (
                                                        <Alert severity="warning" className="mb-4">
                                                            <div className="flex items-start gap-3">
                                                                <Iconify icon="mdi:alert-circle" className="w-6 h-6 text-amber-600 mt-0.5 flex-shrink-0" />
                                                                <div className="flex-1">
                                                                    <h4 className="text-sm font-semibold text-amber-900 mb-1"> Template Obrigatório </h4>
                                                                    <p className="text-sm text-amber-800">
                                                                        Como o canal é WhatsApp Business, é obrigatório selecionar um template para enviar pesquisa
                                                                        de satisfação.
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </Alert>
                                                    )}

                                                    <div className="mt-4 p-4 bg-amber-50 border-2 border-amber-200 rounded-lg">
                                                        <div className="flex items-start gap-3">
                                                            <Iconify icon="mdi:alert-circle" className="w-6 h-6 text-amber-600 mt-0.5" />
                                                            <div className="flex-1">
                                                                <h4 className="text-sm font-semibold text-amber-900 mb-2">
                                                                    {' '}
                                                                    Canal de Whatsapp Business selecionado{' '}
                                                                </h4>
                                                                <p className="text-xs text-amber-800 mb-2">
                                                                    Preencha o template e o campo de mensagem abaixo. O template será usado para mensagens fora da
                                                                    janela de 24 horas, e a mensagem será usada dentro da janela de 24 horas.
                                                                </p>
                                                                <div className="flex flex-wrap gap-2 mt-2">
                                                                    <div className="flex items-center gap-1 px-2 py-1 bg-purple-100 text-purple-700 rounded text-xs font-medium">
                                                                        <Iconify icon="mdi:clock-outline" className="w-3 h-3" /> Template: Fora da janela de 24h
                                                                    </div>
                                                                    <div className="flex items-center gap-1 px-2 py-1 bg-blue-100 text-blue-700 rounded text-xs font-medium">
                                                                        <Iconify icon="mdi:clock-check" className="w-3 h-3" /> Mensagem: Dentro da janela de 24h
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="mt-4 grid grid-cols-1 lg:grid-cols-2 gap-4">
                                                        <div className="space-y-4 lg:pr-4 lg:border-r lg:border-gray-300">
                                                            <div>
                                                                <div className="flex items-center gap-2 mb-2">
                                                                    <Label className="block text-sm font-medium">
                                                                        {' '}
                                                                        Template do WhatsApp {templateObrigatorio && <span className="text-red-600 ml-1">*</span>}{' '}
                                                                    </Label>
                                                                    {config?.generalConfig?.feedbackTemplate ? (
                                                                        <div className="w-5 h-5 bg-green-500 rounded-full flex items-center justify-center">
                                                                            <Iconify icon="mdi:check" className="w-3 h-3 text-white" />
                                                                        </div>
                                                                    ) : (
                                                                        <div className="w-5 h-5 bg-red-500 rounded-full flex items-center justify-center">
                                                                            <Iconify icon="mdi:alert" className="w-3 h-3 text-white" />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                <div className="mb-2 flex items-center justify-between gap-2">
                                                                    <div className="inline-flex items-center gap-1 px-2 py-1 bg-purple-100 text-purple-700 rounded-md text-xs font-medium border border-purple-200">
                                                                        <Iconify icon="mdi:clock-outline" className="w-3 h-3" />{' '}
                                                                        <span>
                                                                            Para mensagens <strong>fora</strong> da janela de 24 horas
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <Select
                                                                    value={selectedTemplateId}
                                                                    onValueChange={handleSelecionarTemplate}
                                                                    onOpenChange={(open) => {
                                                                        setSelectTemplateOpen(open);
                                                                        if (open && canal?.cliente_id && !loadingTemplates) {
                                                                            buscarTemplates();
                                                                        }
                                                                    }}
                                                                    disabled={loadingTemplates}
                                                                >
                                                                    <SelectTrigger
                                                                        className={`w-full ${templateObrigatorio && !config?.generalConfig?.feedbackTemplate
                                                                            ? 'border-red-300 focus:border-red-500 ring-red-200'
                                                                            : config?.generalConfig?.feedbackTemplate
                                                                                ? 'border-purple-300 focus:border-purple-500'
                                                                                : ''
                                                                            }`}
                                                                    >
                                                                        {loadingTemplates ? (
                                                                            <div className="flex items-center gap-2">
                                                                                <CircularProgress size={16} />
                                                                                <span className="text-sm text-gray-500">Carregando templates...</span>
                                                                            </div>
                                                                        ) : (
                                                                            <SelectValue placeholder="Selecione um template">
                                                                                {config?.generalConfig?.feedbackTemplate ? config.generalConfig.feedbackTemplate.name : null}
                                                                            </SelectValue>
                                                                        )}
                                                                    </SelectTrigger>
                                                                    <SelectContent className="max-h-[400px]">
                                                                        <SelectItem value="none">
                                                                            <div className="flex items-center gap-2">
                                                                                <Iconify icon="mdi:close-circle" className="w-4 h-4 text-gray-400" />
                                                                                <span className="text-gray-500">Nenhum template selecionado</span>
                                                                            </div>
                                                                        </SelectItem>
                                                                        {templates.length === 0 ? (
                                                                            <div className="px-2 py-6 text-center">
                                                                                <Iconify
                                                                                    icon="mdi:file-document-remove-outline"
                                                                                    className="w-10 h-10 text-gray-300 mx-auto mb-2"
                                                                                />
                                                                                <p className="text-sm text-gray-500">Nenhum template disponível</p>
                                                                            </div>
                                                                        ) : (
                                                                            templates.map((template) => {
                                                                                const comps = normalizarComponents(template?.components || []);
                                                                                const conteudo = comps?.find((c) => c.type === 'BODY')?.text || '';
                                                                                const temVariaveis = (conteudo.match(/\{\{\d+\}\}/g) || []).length > 0;
                                                                                const templateName = template.name || template.templateName || 'Sem nome';
                                                                                const categoria = transformCategoryTemplateWhatsApp(template?.category) || 'N/A';
                                                                                const templateIdValue = String(template.templateId || template._id);
                                                                                const isSelected =
                                                                                    String(config?.generalConfig?.feedbackTemplate?.templateId || '') === templateIdValue;
                                                                                return (
                                                                                    <SelectItem key={templateIdValue} value={templateIdValue}>
                                                                                        <div className="flex items-start gap-3 w-full py-1">
                                                                                            <div
                                                                                                className={`w-8 h-8 rounded-lg flex items-center justify-center text-white text-xs flex-shrink-0 ${isSelected ? 'bg-gradient-to-br from-purple-500 to-purple-600' : 'bg-gray-400'
                                                                                                    }`}
                                                                                            >
                                                                                                📄
                                                                                            </div>
                                                                                            <div className="flex-1 min-w-0 space-y-1">
                                                                                                <div className="flex items-center gap-2">
                                                                                                    <span className="font-medium text-sm text-gray-900">{templateName}</span>
                                                                                                    {isSelected && <Iconify icon="mdi:check-circle" className="w-4 h-4 text-green-500" />}
                                                                                                </div>
                                                                                                <div className="flex items-center gap-2 flex-wrap">
                                                                                                    <span className="text-xs px-2 py-0.5 bg-gray-100 text-gray-600 rounded">
                                                                                                        {categoria}
                                                                                                    </span>
                                                                                                    {temVariaveis && (
                                                                                                        <span className="text-xs px-2 py-0.5 bg-purple-100 text-purple-600 rounded">
                                                                                                            {' '}
                                                                                                            Com variáveis{' '}
                                                                                                        </span>
                                                                                                    )}
                                                                                                </div>
                                                                                                <p className="text-xs text-gray-500 truncate">{conteudo || 'Sem conteúdo'}</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </SelectItem>
                                                                                );
                                                                            })
                                                                        )}
                                                                    </SelectContent>
                                                                </Select>
                                                                {!config?.generalConfig?.feedbackTemplate && templateObrigatorio && (
                                                                    <p className="text-xs text-red-600 mt-1 flex items-center gap-1">
                                                                        <Iconify icon="mdi:alert-circle" className="w-3 h-3" /> Selecione um template (obrigatório para
                                                                        WhatsApp Business)
                                                                    </p>
                                                                )}
                                                            </div>
                                                            {config?.generalConfig?.feedbackTemplate && (
                                                                <div className="border-2 border-purple-200 rounded-lg overflow-hidden bg-white shadow-sm">
                                                                    <div className="bg-gradient-to-r from-purple-50 to-purple-100 px-4 py-3 border-b border-purple-200">
                                                                        <div className="flex items-center justify-between">
                                                                            <div className="flex items-center gap-3">
                                                                                <div className="w-10 h-10 bg-gradient-to-br from-purple-500 to-purple-600 rounded-lg flex items-center justify-center text-white text-lg shadow-sm">
                                                                                    📄
                                                                                </div>
                                                                                <div>
                                                                                    <h3 className="font-semibold text-sm text-gray-900">
                                                                                        {config.generalConfig.feedbackTemplate.name}
                                                                                    </h3>
                                                                                    <p className="text-xs text-gray-600 mt-0.5">
                                                                                        ID: {config.generalConfig.feedbackTemplate.templateId}
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="p-4 max-h-[400px] overflow-y-auto">
                                                                        <div className="bg-gray-100 rounded-lg p-4">
                                                                            <div className="bg-white rounded-lg p-4 shadow-sm border border-gray-200">
                                                                                <div className="text-sm text-gray-800 leading-relaxed">
                                                                                    {config?.generalConfig?.feedbackTemplateVariaveis &&
                                                                                        Object.keys(config.generalConfig.feedbackTemplateVariaveis).length > 0 ? (
                                                                                        <div className="space-y-1">
                                                                                            {config.generalConfig.feedbackTemplate.conteudo
                                                                                                .split(/(\{\{\d+\}\})/g)
                                                                                                .map((parte, index) => {
                                                                                                    const match = parte.match(/\{\{(\d+)\}\}/);
                                                                                                    if (match) {
                                                                                                        const numeroVariavel = match[1];
                                                                                                        const valorVariavel =
                                                                                                            config.generalConfig.feedbackTemplateVariaveis[numeroVariavel] || '';
                                                                                                        return (
                                                                                                            <span key={index} className="inline-block">
                                                                                                                {valorVariavel ? (
                                                                                                                    <span className="inline-block px-2 py-1 mx-1 bg-purple-100 text-purple-800 rounded border border-purple-300 font-medium">
                                                                                                                        {valorVariavel}
                                                                                                                    </span>
                                                                                                                ) : (
                                                                                                                    <span className="inline-block px-2 py-1 mx-1 bg-purple-50 text-purple-600 rounded border-2 border-dashed border-purple-300 italic">
                                                                                                                        {`{{${numeroVariavel}}}`}
                                                                                                                    </span>
                                                                                                                )}
                                                                                                            </span>
                                                                                                        );
                                                                                                    }
                                                                                                    return (
                                                                                                        <span key={index} className="whitespace-pre-wrap">
                                                                                                            {parte}
                                                                                                        </span>
                                                                                                    );
                                                                                                })}
                                                                                        </div>
                                                                                    ) : (
                                                                                        <span className="whitespace-pre-wrap">
                                                                                            {config.generalConfig.feedbackTemplate.conteudo}
                                                                                        </span>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        {config?.generalConfig?.feedbackTemplateVariaveis &&
                                                                            Object.keys(config.generalConfig.feedbackTemplateVariaveis).length > 0 && (
                                                                                <div className="mt-4 space-y-3">
                                                                                    <h4 className="text-sm font-medium text-gray-900 mb-3"> Variáveis do Template </h4>
                                                                                    {Object.keys(config.generalConfig.feedbackTemplateVariaveis)
                                                                                        .sort((a, b) => parseInt(a) - parseInt(b))
                                                                                        .map((variavelKey) => (
                                                                                            <div key={variavelKey} className="bg-gray-50 rounded-lg p-3 border border-gray-200">
                                                                                                <div className="flex items-center gap-2 mb-2">
                                                                                                    <span className="inline-flex items-center justify-center w-6 h-6 bg-purple-100 text-purple-700 rounded-full text-xs font-semibold">
                                                                                                        {variavelKey}
                                                                                                    </span>
                                                                                                    <Label className="text-xs font-medium text-gray-700">
                                                                                                        {' '}
                                                                                                        Variável {variavelKey}{' '}
                                                                                                    </Label>
                                                                                                    <span className="text-xs text-gray-400 font-mono"> {`{{${variavelKey}}}`} </span>
                                                                                                </div>
                                                                                                <Input
                                                                                                    value={config.generalConfig.feedbackTemplateVariaveis[variavelKey] || ''}
                                                                                                    onChange={(e) => {
                                                                                                        const variaveisAtuais = config?.generalConfig?.feedbackTemplateVariaveis || {};
                                                                                                        onChange({
                                                                                                            target: {
                                                                                                                name: 'generalConfig.feedbackTemplateVariaveis',
                                                                                                                value: { ...variaveisAtuais, [variavelKey]: e.target.value },
                                                                                                            },
                                                                                                        });
                                                                                                    }}
                                                                                                    placeholder={`Digite o valor para a variável {{${variavelKey}}}`}
                                                                                                    className="bg-white border-purple-200 focus:border-purple-500 focus:ring-purple-500"
                                                                                                />
                                                                                                {!config.generalConfig.feedbackTemplateVariaveis[variavelKey] && (
                                                                                                    <p className="text-xs text-amber-600 mt-1 flex items-center gap-1">
                                                                                                        <Iconify icon="mdi:alert-circle" className="w-3 h-3" /> Esta variável precisa
                                                                                                        ser preenchida
                                                                                                    </p>
                                                                                                )}
                                                                                            </div>
                                                                                        ))}
                                                                                </div>
                                                                            )}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className="space-y-4 lg:pl-4 border-dashed">
                                                            <div>
                                                                <div className="flex items-center gap-2 mb-2">
                                                                    <Label className="block text-sm font-medium"> Mensagem da pesquisa </Label>
                                                                </div>
                                                                <div className="mb-2">
                                                                    <div className="inline-flex items-center gap-1 px-2 py-1 bg-blue-100 text-blue-700 rounded-md text-xs font-medium border border-blue-200">
                                                                        <Iconify icon="mdi:clock-check" className="w-3 h-3" />{' '}
                                                                        <span>
                                                                            Para mensagens <strong>dentro</strong> da janela de 24 horas
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <RowInput
                                                                    sx={{ width: '100%' }}
                                                                    label=""
                                                                    input={
                                                                        <Textarea
                                                                            multiline
                                                                            rows={15}
                                                                            size="small"
                                                                            name="generalConfig.msgs.feedback"
                                                                            onChange={onChange}
                                                                            value={config?.generalConfig?.msgs?.feedback}
                                                                            fullWidth
                                                                        />
                                                                    }
                                                                />
                                                                {!config?.generalConfig?.msgs?.feedback && (
                                                                    <p className="text-xs text-amber-600 mt-1 flex items-center gap-1">
                                                                        <Iconify icon="mdi:alert-circle" className="w-3 h-3" /> É necessário preencher o campo de
                                                                        mensagem para enviar dentro da janela de 24 horas
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            ) : (
                                                <RowInput
                                                    sx={{ width: '100%' }}
                                                    label="Mensagem da pesquisa"
                                                    input={
                                                        <Textarea
                                                            multiline
                                                            rows={5}
                                                            size="small"
                                                            name="generalConfig.msgs.feedback"
                                                            onChange={onChange}
                                                            value={config?.generalConfig?.msgs?.feedback}
                                                            fullWidth
                                                        />
                                                    }
                                                />
                                            )}
                                        </div>
                                    </TabsContent>
                                    <TabsContent value="welcome">
                                        <div className="flex flex-col gap-4 mt-8">
                                            <h4 className="scroll-m-20 text-md font-semibold tracking-tight"> Mensagem Boas Vindas </h4>
                                            <Textarea
                                                multiline
                                                rows={5}
                                                size="small"
                                                value={config?.generalConfig?.msgs?.welcome}
                                                name="generalConfig.msgs.welcome"
                                                onChange={onChange}
                                                fullWidth
                                            />
                                        </div>
                                    </TabsContent>
                                    <TabsContent value="afterTarget">
                                        <div className="flex flex-col gap-4 mt-8">
                                            <h4 className="scroll-m-20 text-md font-semibold tracking-tight"> Mensagem após direcionamento </h4>
                                            <Textarea
                                                multiline
                                                rows={5}
                                                size="small"
                                                value={config?.generalConfig?.msgs?.afterTarget}
                                                name="generalConfig.msgs.afterTarget"
                                                onChange={onChange}
                                                fullWidth
                                            />
                                        </div>
                                    </TabsContent>
                                </Tabs>
                            </CardContent>
                        </Card>
                    )}
                </TabsContent>
                <TabsContent value="setores">
                    {isEdit && (
                        <div className="flex flex-col gap-4">
                            <Card className="py-5">
                                <CardContent>
                                    <div className="flex flex-col gap-4">
                                        <h4 className="scroll-m-20 text-md font-semibold tracking-tight"> Configurações de Setor </h4>
                                        <div className="my-2 w-1/3">
                                            <RowInput
                                                label={'SLA tempo de aceite (minutos)'}
                                                input={
                                                    <Input
                                                        type="number"
                                                        min={1}
                                                        placeholder="5"
                                                        value={config?.sla_tempo_aceite ? config.sla_tempo_aceite / 60 : ''}
                                                        onChange={(e) => {
                                                            onChange({ target: { name: 'sla_tempo_aceite', value: e.target.value } });
                                                        }}
                                                    />
                                                }
                                            />
                                        </div>
                                        <Divider className="border-dashed" />
                                        <div className="my-4 w-1/3">
                                            <RowInput
                                                label={'Setor padrão'}
                                                input={
                                                    <Select
                                                        value={config?.departamentConfig?.defaultSector || ''}
                                                        onValueChange={async (value) => {
                                                            const event = { target: { name: 'departamentConfig.defaultSector', value: value } };
                                                            onChange(event);
                                                        }}
                                                    >
                                                        <SelectTrigger className="w-full">
                                                            {config?.departamentConfig?.defaultSector
                                                                ? newListSectors.find((item) => item.value === config?.departamentConfig?.defaultSector)
                                                                    ?.label
                                                                : 'Selecione um setor padrão'}
                                                        </SelectTrigger>
                                                        <SelectContent>
                                                            {newListSectors?.map((item) => (
                                                                <SelectItem key={item.value} value={item.value}>
                                                                    {item.label}
                                                                </SelectItem>
                                                            ))}
                                                        </SelectContent>
                                                    </Select>
                                                }
                                            />
                                        </div>
                                        <Divider className="border-dashed" />
                                        <div className="flex items-center space-x-2">
                                            <Switch
                                                checked={config?.departamentConfig?.wallet?.status}
                                                onCheckedChange={(value) => {
                                                    let e = { target: { name: 'departamentConfig.wallet.status', value: value } };
                                                    onChange(e);
                                                }}
                                                id="airplane-mode"
                                            />
                                            <Label htmlFor="airplane-mode">Carteirização de clientes (Beta)</Label>
                                            <ZuiTooltip content="Um chat fica vinculado a um atendente. Caso chat atendimento seja encerrado e o contato futuramente voltar a ser atendido, será direcionado para o atendente vinculado ao chat">
                                                <Box>
                                                    <Iconify icon={'ph:info-bold'} width={18} height={18} />
                                                </Box>
                                            </ZuiTooltip>
                                        </div>
                                        <Divider className="border-dashed" />
                                        <div className="flex items-center space-x-2">
                                            <Switch
                                                checked={config?.departamentConfig?.allocate?.status}
                                                onCheckedChange={(value) => {
                                                    let e = { target: { name: 'departamentConfig.allocate.status', value: value } };
                                                    onChange(e);
                                                }}
                                                id="airplane-mode"
                                            />
                                            <Label htmlFor="airplane-mode">Distribuir atendimentos entre usuários do setor</Label>
                                            <ZuiTooltip content="Se direcionado para setores, o sistema irá distribuir entre os usuarios">
                                                <Box>
                                                    <Iconify icon={'ph:info-bold'} width={18} height={18} />
                                                </Box>
                                            </ZuiTooltip>
                                        </div>
                                        <div className="flex items-center space-x-2">
                                            <Switch
                                                checked={config?.departamentConfig?.allocate?.ignoreUsersOff}
                                                onCheckedChange={(value) => {
                                                    let e = { target: { name: 'departamentConfig.allocate.ignoreUsersOff', value: value } };
                                                    onChange(e);
                                                }}
                                                id="airplane-mode"
                                            />
                                            <Label htmlFor="airplane-mode">Ignorar usuarios em intervalo</Label>
                                            <ZuiTooltip content="Ignora usuario que estão em intervalo de tempo ativado">
                                                <Box>
                                                    <Iconify icon={'ph:info-bold'} width={18} height={18} />
                                                </Box>
                                            </ZuiTooltip>
                                        </div>
                                        <RowInput
                                            label={'Tipo'}
                                            input={
                                                <RadioGroup
                                                    value={config?.departamentConfig?.allocate?.type}
                                                    onValueChange={(value) => onChange({ target: { name: 'departamentConfig.allocate.type', value: value } })}
                                                    className="grid grid-cols-3 gap-4"
                                                >
                                                    {optionsAllocate.map((option) => (
                                                        <div className="cursor-pointer w-full" key={option.value}>
                                                            <RadioGroupItem value={option.value} id={option.value} className="peer sr-only" />
                                                            <ZuiTooltip content={option.description}>
                                                                <Label
                                                                    htmlFor={option.value}
                                                                    className={`flex flex-col items-center justify-between rounded-md border-2 border-muted bg-popover p-2 hover:bg-accent hover:text-accent-foreground ${config?.departamentConfig?.allocate?.type === option.value ? 'bg-slate-500 text-white' : ''
                                                                        }`}
                                                                >
                                                                    {option.label}
                                                                </Label>
                                                            </ZuiTooltip>
                                                        </div>
                                                    ))}
                                                </RadioGroup>
                                            }
                                        />
                                        {config?.departamentConfig?.allocate?.type === 'sequential' && (
                                            <div className="mt-4 flex flex-col gap-2 w-2/3">
                                                <label className="text-[14px]">periodo de distribuição</label>
                                                <RadioGroup
                                                    defaultValue="daily"
                                                    className="flex flex-row gap-4 mt-4"
                                                    value={config?.departamentConfig?.allocate?.period}
                                                    onValueChange={(value) =>
                                                        onChange({ target: { name: 'departamentConfig.allocate.period', value: value } })
                                                    }
                                                >
                                                    {optionsPeriod.map((option) => (
                                                        <div className="cursor-pointer w-full" key={option.value}>
                                                            <RadioGroupItem value={option.value} id={option.value} className="peer sr-only" />
                                                            <ZuiTooltip content={option.description}>
                                                                <Label
                                                                    htmlFor={option.value}
                                                                    className={`flex flex-col items-center justify-between rounded-md border-2 border-muted bg-popover p-2 hover:bg-accent hover:text-accent-foreground ${config?.departamentConfig?.allocate?.period === option.value ? 'bg-slate-500 text-white' : ''
                                                                        }`}
                                                                >
                                                                    {option.label}
                                                                </Label>
                                                            </ZuiTooltip>
                                                        </div>
                                                    ))}
                                                </RadioGroup>
                                            </div>
                                        )}
                                    </div>
                                </CardContent>
                            </Card>
                        </div>
                    )}
                </TabsContent>
                <TabsContent value="ia">
                    <div className="flex flex-col gap-4">
                        <Card>
                            <CardContent className="p-5">
                                <div className="flex flex-col gap-4">
                                    <h4 className="scroll-m-20 text-md font-semibold tracking-tight"> Lais Go </h4>
                                    <div className="flex items-center space-x-2">
                                        <Label htmlFor="airplane-mode">Silenciar IA com etiqueta</Label>
                                        <ZuiTooltip content="Silencia IA ao adicionar uma etiqueta na conversa do whatsapp(aparelho)">
                                            <Box>
                                                <Iconify icon={'ph:info-bold'} width={18} height={18} />
                                            </Box>
                                        </ZuiTooltip>
                                        <Switch
                                            checked={config?.laisGo?.status}
                                            onCheckedChange={(value) => {
                                                let e = { target: { name: 'laisGo.status', value: value } };
                                                onChange(e);
                                            }}
                                            id="airplane-mode"
                                        />
                                    </div>
                                </div>
                            </CardContent>
                        </Card>
                        {cliente && cliente.features && verifyFeatures(cliente.features, 'ai.analise_atendimento') && (
                            <Card>
                                <CardContent className="p-5">
                                    <div className="my-4">
                                        <h5 className="scroll-m-20 text-md font-semibold tracking-tight"> Análise de atendimento </h5>
                                    </div>
                                    <div className="grid grid-cols-1 gap-6">
                                        <div className="flex flex-row gap-4 items-center">
                                            <Label htmlFor="status" className="min-w-[200px] text-right">
                                                Status
                                            </Label>
                                            <div className="flex flex-row gap-2 items-center">
                                                <Switch
                                                    id="status"
                                                    checked={config?.ai?.modules?.aiAnalysisChat?.status}
                                                    onCheckedChange={(value) => {
                                                        let e = { target: { name: 'ai.modules.aiAnalysisChat.status', value: value } };
                                                        onChange(e);
                                                    }}
                                                />
                                                <p className="text-sm text-muted-foreground"> Ative ou desative a análise de atendimento </p>
                                            </div>
                                        </div>
                                        <div className="flex flex-row gap-4 items-center">
                                            <Label htmlFor="quantidade" className="min-w-[200px] text-right">
                                                Mensagens até a análise
                                            </Label>
                                            <div className="flex flex-row gap-2 items-center">
                                                <Input
                                                    id="quantidade"
                                                    type="number"
                                                    value={config?.ai?.modules?.aiAnalysisChat?.numberMsgs}
                                                    onChange={(event) => {
                                                        let e = { target: { name: 'ai.modules.aiAnalysisChat.numberMsgs', value: Number(event.target.value) } };
                                                        onChange(e);
                                                    }}
                                                    min={1}
                                                    className="w-[100px]"
                                                />
                                                <p className="text-sm text-muted-foreground">
                                                    {' '}
                                                    Número de mensagens enviadas pelo cliente necessárias para gerar próxima análise{' '}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="flex flex-row gap-4 items-center">
                                            <Label className="min-w-[200px] text-right">Atuação da Análise</Label>
                                            <div className="flex flex-col gap-2">
                                                <MultiSelect
                                                    options={newOpcoesMomentos}
                                                    defaultValue={config?.ai?.modules?.aiAnalysisChat?.operation}
                                                    onValueChange={(newValue) => {
                                                        let e = { target: { name: 'ai.modules.aiAnalysisChat.operation', value: newValue } };
                                                        onChange(e);
                                                    }}
                                                    labelledBy="Selecione os momentos"
                                                    hasSelectAll={true}
                                                    className="w-[300px]"
                                                    placeholder="Selecione os momentos"
                                                />
                                                <p className="text-sm text-muted-foreground"> Selecione quando a análise deve ser gerada </p>
                                            </div>
                                        </div>
                                        <div className="grid grid-cols-1 gap-6">
                                            <div className="flex flex-row gap-4 items-center">
                                                <Label htmlFor="customPrompts" className="min-w-[200px] text-right">
                                                    Usar Prompts Customizados
                                                </Label>
                                                <div className="flex flex-row gap-2 items-center">
                                                    <Switch
                                                        id="customPrompts"
                                                        checked={config?.ai?.modules?.aiAnalysisChat?.customPrompts}
                                                        onCheckedChange={(value) => {
                                                            let e = { target: { name: 'ai.modules.aiAnalysisChat.customPrompts', value: value } };
                                                            onChange(e);
                                                        }}
                                                    />
                                                    <p className="text-sm text-muted-foreground">
                                                        {' '}
                                                        Ative para usar prompts personalizados para cada tipo de análise{' '}
                                                    </p>
                                                </div>
                                            </div>
                                            {config?.ai?.modules?.aiAnalysisChat?.customPrompts && (
                                                <div className="space-y-6">
                                                    <Separator />
                                                    <div className="space-y-4">
                                                        <Label className="text-sm font-medium">Prompt para Alertas</Label>
                                                        <Textarea
                                                            placeholder="Digite o prompt para análise de alertas..."
                                                            value={config?.ai?.modules?.aiAnalysisChat?.prompt_alerts || ''}
                                                            onChange={(event) => {
                                                                let e = { target: { name: 'ai.modules.aiAnalysisChat.prompt_alerts', value: event.target.value } };
                                                                onChange(e);
                                                            }}
                                                            rows={3}
                                                            className="w-full"
                                                        />
                                                        <p className="text-xs text-muted-foreground"> Instruções específicas para análise de alertas </p>
                                                    </div>
                                                    <div className="space-y-4">
                                                        <Label className="text-sm font-medium">Prompt Preditivo</Label>
                                                        <Textarea
                                                            placeholder="Digite o prompt para análise preditiva..."
                                                            value={config?.ai?.modules?.aiAnalysisChat?.prompt_predictive || ''}
                                                            onChange={(event) => {
                                                                let e = { target: { name: 'ai.modules.aiAnalysisChat.prompt_predictive', value: event.target.value } };
                                                                onChange(e);
                                                            }}
                                                            rows={3}
                                                            className="w-full"
                                                        />
                                                        <p className="text-xs text-muted-foreground"> Instruções para análise preditiva do atendimento </p>
                                                    </div>
                                                    <div className="space-y-4">
                                                        <Label className="text-sm font-medium">Prompt para Resumo</Label>
                                                        <Textarea
                                                            placeholder="Digite o prompt para resumo do atendimento..."
                                                            value={config?.ai?.modules?.aiAnalysisChat?.prompt_resume || ''}
                                                            onChange={(event) => {
                                                                let e = { target: { name: 'ai.modules.aiAnalysisChat.prompt_resume', value: event.target.value } };
                                                                onChange(e);
                                                            }}
                                                            rows={3}
                                                            className="w-full"
                                                        />
                                                        <p className="text-xs text-muted-foreground"> Instruções para geração do resumo do atendimento </p>
                                                    </div>
                                                    <div className="space-y-4">
                                                        <Label className="text-sm font-medium">Prompt para Sentimento</Label>
                                                        <Textarea
                                                            placeholder="Digite o prompt para análise de sentimento..."
                                                            value={config?.ai?.modules?.aiAnalysisChat?.prompt_sentiment || ''}
                                                            onChange={(event) => {
                                                                let e = { target: { name: 'ai.modules.aiAnalysisChat.prompt_sentiment', value: event.target.value } };
                                                                onChange(e);
                                                            }}
                                                            rows={3}
                                                            className="w-full"
                                                        />
                                                        <p className="text-xs text-muted-foreground"> Instruções para análise do sentimento do cliente </p>
                                                    </div>
                                                    <div className="space-y-4">
                                                        <Label className="text-sm font-medium">Prompt para Assuntos</Label>
                                                        <Textarea
                                                            placeholder="Digite o prompt para identificação de assuntos..."
                                                            value={config?.ai?.modules?.aiAnalysisChat?.prompt_subject || ''}
                                                            onChange={(event) => {
                                                                let e = { target: { name: 'ai.modules.aiAnalysisChat.prompt_subject', value: event.target.value } };
                                                                onChange(e);
                                                            }}
                                                            rows={3}
                                                            className="w-full"
                                                        />
                                                        <p className="text-xs text-muted-foreground"> Instruções para identificação dos assuntos tratados </p>
                                                    </div>
                                                    <div className="space-y-4">
                                                        <Label className="text-sm font-medium">Prompt para Sugestões</Label>
                                                        <Textarea
                                                            placeholder="Digite o prompt para geração de sugestões..."
                                                            value={config?.ai?.modules?.aiAnalysisChat?.prompt_suggestion || ''}
                                                            onChange={(event) => {
                                                                let e = {
                                                                    target: { name: 'ai.modules.aiAnalysisChat.prompt_suggestion', value: event.target.value },
                                                                };
                                                                onChange(e);
                                                            }}
                                                            rows={3}
                                                            className="w-full"
                                                        />
                                                        <p className="text-xs text-muted-foreground"> Instruções para geração de sugestões de melhoria </p>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </CardContent>
                            </Card>
                        )}
                        <Card>
                            <CardContent className="p-5">
                                <div className="my-4">
                                    <h5 className="scroll-m-20 text-md font-semibold tracking-tight"> Conversação por IA </h5>
                                </div>
                                <div className="grid grid-cols-1 gap-6">
                                    <div className="flex flex-row gap-4 items-center">
                                        <Label htmlFor="status" className="min-w-[200px] text-right">
                                            Transcrição Audio
                                        </Label>
                                        <div className="flex flex-row gap-2 items-center">
                                            <Switch
                                                id="status"
                                                checked={config?.ai?.autoTranscribeAudio}
                                                onCheckedChange={(value) => {
                                                    let e = { target: { name: 'ai.autoTranscribeAudio', value: value } };
                                                    onChange(e);
                                                }}
                                            />
                                            <p className="text-sm text-muted-foreground">
                                                {' '}
                                                Esta opção trascreve as mensagens do audio para texto automaticamente. Obrigatório para analise de
                                                atendimento{' '}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="flex flex-row gap-4 items-center">
                                        <Label htmlFor="status" className="min-w-[200px] text-right">
                                            Trancrição de imagens
                                        </Label>
                                        <div className="flex flex-row gap-2 items-center">
                                            <Switch
                                                id="status"
                                                checked={config?.ai?.autoTranscribeImage}
                                                onCheckedChange={(value) => {
                                                    let e = { target: { name: 'ai.autoTranscribeImage', value: value } };
                                                    onChange(e);
                                                }}
                                            />
                                            <p className="text-sm text-muted-foreground">
                                                {' '}
                                                Esta opção trascreve as mensagens das imagens para texto automaticamente.{' '}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </CardContent>
                        </Card>
                    </div>
                </TabsContent>
                <TabsContent value="saude" className="space-y-4">
                    <Card className="py-5">
                        <CardContent>
                            <ChannelHealth canal={canal} session={canal?.config?.sessao} />
                        </CardContent>
                    </Card>
                </TabsContent>
                <TabsContent value="templates" className="space-y-4">
                    <Card className="py-5">
                        <CardContent>
                            <TemplatesWhatsappPage />
                        </CardContent>
                    </Card>
                </TabsContent>
            </Tabs>
            {!isEdit && (
                <Stack direction={'row'} sx={{ mt: 2 }}>
                    <Button
                        onClick={onSubmit}
                        sx={{ width: '20%' }}
                        variant="contained"
                        color="success"
                        size="large"
                        startIcon={<Iconify icon="majesticons:save-line" color="white" width={20} height={20} />}
                    >
                        <Typography variant="body2" sx={{ fontWeight: 600, textTransform: 'lowercase', color: '#fff' }}>
                            {isEdit ? 'salvar' : 'criar canal'}
                        </Typography>
                    </Button>
                </Stack>
            )}
        </Scrollbar>
    );
}

